import { render, staticRenderFns } from "./PrestVariantPierreVacance.vue?vue&type=template&id=6ffd5064&scoped=true"
import script from "./PrestVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrestVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PrestVariantPierreVacance.vue?vue&type=style&index=0&id=6ffd5064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffd5064",
  null
  
)

export default component.exports